import { List, Segment } from "semantic-ui-react";
import { ExaminerListItem, ManageExaminerToRoomStructureExaminerListItem } from "./ManageExaminerToRoomStructureExaminerListItem";

export type Props = {
  examiners: ExaminerListItem[];
  selectedExaminerId?: number;
  onExaminerSelect: (examinerId: number) => void;
}

export const ManageExaminerToRoomStructureSearchResults = ({ examiners, selectedExaminerId, onExaminerSelect }: Props) => {
  return (
    <Segment secondary>
      {examiners.length === 0 ? (
        <List.Item>
          <List.Header>No examiners were found matching the selected criteria</List.Header>
        </List.Item>
      ) : (
        <List selection relaxed>
          {examiners.map((examiner) => (
            <ManageExaminerToRoomStructureExaminerListItem examiner={examiner} key={`manage-examiner-${examiner.id}`} selectedExaminerId={selectedExaminerId} onExaminerSelect={onExaminerSelect} />
          ))}
        </List>
      )}
    </Segment>
  );
};